import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const HorizontalCardContainer = styled.div<React.CSSProperties>`
  border: ${4 * Screen.widthRatio}px solid transparent;
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  height: ${197 * Screen.widthRatio}px;
  margin-right: ${4 * Screen.widthRatio}px;
  overflow: hidden;
  width: ${350 * Screen.widthRatio}px;
  &:hover {
    border: ${4 * Screen.widthRatio}px solid white;
  }
`;

export default HorizontalCardContainer;
